import { Button } from "@nxtvid/component-library"
import './checkoutCancel.css';

const CheckOutCancel = () =>{
    return(
        <div className="checkout-cancel-message">
            <h2>Payment Cancelled</h2>
            <p>Your payment was not completed. If you wish to try again, please return to your inbox and restart the checkout process.</p>
            <Button size='medium' type='primary' label='Go Back to Inbox' onClick={()=>window.location.href = '/Inbox'}/>
        </div>
    )
}

export default CheckOutCancel;